/**
 * @fileoverview POST handler for the "/:app_group_id/knowledge_source/definition" endpoint
 */
import { exhaustiveCheck } from "@lib/exhaustiveCheck";
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { knowledgeSourceDefinitionCacheKeys } from "./constants";
import type {
  KnowledgeSourceDefinitionResult,
  PostKnowledgeSourceDefinitionErrors,
  PostKnowledgeSourceDefinitionProps,
} from "./types";

const buildCreateParams = (props: PostKnowledgeSourceDefinitionProps): Record<string, unknown> => {
  const base = {
    description: props.description,
    type: props.type,
  };

  switch (props.type) {
    case "catalog":
      return { ...base, catalog_id: props.catalogId };
    default:
      exhaustiveCheck(props as never);
      return base;
  }
};

export const postKnowledgeSourceDefinition = reactQueryMutationAdapter(
  knowledgeSourceDefinitionCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostKnowledgeSourceDefinitionErrors>()(
    (props: PostKnowledgeSourceDefinitionProps): Promise<KnowledgeSourceDefinitionResult> => {
      return fetch(
        `/${props.appGroupId}/knowledge_source/definition`,
        "POST",
        buildCreateParams(props),
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
